/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Footer_SupportInputs */

const en_landing_footer_support = /** @type {(inputs: Landing_Footer_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support`)
};

const id_landing_footer_support = /** @type {(inputs: Landing_Footer_SupportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bantuan`)
};

/**
* | output |
* | --- |
* | "Support" |
*
* @param {Landing_Footer_SupportInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const landing_footer_support = /** @type {((inputs?: Landing_Footer_SupportInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Footer_SupportInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_landing_footer_support(inputs)
	return en_landing_footer_support(inputs)
});